export default "__VITE_ASSET__CNMrpivO__"